import { Kundetype, Produkt } from "codegen";
import { isWithinInterval } from "date-fns";

import { faWarning } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Direction, Flex, Justify } from "@ntemarked/mittne-components/dist/Flex/Flex";

import Card from "components/molecules/Card";
import { PriceInformation } from "pages/Productadmin/ProductPage/EditProductPage";
import { getUcBaseLink } from "utils/Utils";

function formatValue(value: string, dateFrom: Date, dateTo: Date, isBedrift: boolean) {
	// Verdi is received as string, in kr, without mums
	// Consider moving this to backend

	if (!value) {
		return "";
	}
	let formattedVerdi: string;

	let isNegative: boolean = false;
	let isOere: boolean = false;

	if (value.startsWith("−") || value.startsWith("-")) {
		isNegative = true;
	}

	let numeric = Number(value.replace("−", "").replace("-", "").replace(",", "."));

	if (isNaN(numeric)) {
		return value;
	}
	if (numeric === 0) {
		return "0 kr";
	}

	if (numeric < 1) {
		isOere = true;
		numeric = numeric * 100;
	}

	const withMums = isBedrift ? numeric : numeric * 1.25;
	formattedVerdi = withMums.toFixed(isOere ? 3 : 2).replace(".", ",");

	if (isNegative) {
		// Add "- "
		formattedVerdi = "-" + formattedVerdi;
	}
	if (isOere) {
		formattedVerdi += " øre";
	} else {
		formattedVerdi += " kr";
	}

	// Add "inactive"
	if (dateFrom && dateTo && !isActive(dateFrom, dateTo)) {
		formattedVerdi = formattedVerdi + " (inaktiv)";
	}
	return formattedVerdi;
}

function isActive(dateFrom: Date, dateTo: Date) {
	return isWithinInterval(new Date(), { start: new Date(dateFrom), end: new Date(dateTo) });
}

export function ProduktUCInfo(props: { product: Produkt }) {
	const { product } = props;
	return (
		<Card
			title={
				<>
					{product.navn} fra{" "}
					<a target="_blank" rel="noreferrer" href={`${getUcBaseLink()}/#/products/edit/${product.id}`} title="Se produktet i UC">
						Utility Cloud
					</a>
				</>
			}
		>
			{product.harOrdrebekreftelseIngenIUC === true && (
				<div>
					<Flex direction={Direction.row} alignItems={Justify.center} gap="0.5rem">
						<FontAwesomeIcon icon={faWarning} style={{ marginRight: "0.5rem", color: "orange" }} />
						<div>
							Produktet er blokkert for generering av ordrebekreftelser i UC. Fjern ekstrafeltet "ordrebekreftelse" fra produktet og oppdater før
							du går videre.
						</div>
					</Flex>
					<img
						style={{ maxWidth: "100%", marginTop: "1rem" }}
						src={"/ingen_ordrebekreftelse.png"}
						alt="Ingen ordrebekreftelse feltet i bunnen av nettsiden til Utility Cloud"
					/>
				</div>
			)}
			<PriceInformation>
				Priser:
				<ul>
					{product.utilityCloudPriser?.map((p, i: number) => {
						return (
							<li key={i}>
								{p.navn ? p.navn + ":" : ""}
								<ul>
									{p?.priser?.map((pris, k: number) => {
										return (
											<div key={k}>
												<li>
													{formatValue(
														pris.verdi!,
														new Date(pris.gyldigFra!),
														new Date(pris.gyldigTil!),
														product.kundetype === Kundetype.Bedrift
													)}
												</li>
												{pris.gyldigFra && (
													<ul>
														<li>(Rådata er {pris.verdi}, vanligvis oppgitt i kr uten moms)</li>
														{pris.gyldigFra && <li>Gjelder fra: {new Date(pris.gyldigFra).toLocaleDateString()}</li>}
														{pris.gyldigTil && <li>Gjelder til: {new Date(pris.gyldigTil).toLocaleDateString()}</li>}
													</ul>
												)}
											</div>
										);
									})}
								</ul>
							</li>
						);
					})}
				</ul>
			</PriceInformation>
		</Card>
	);
}
